import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=389fa40e&scoped=true"
import script from "./CardSkeleton.vue?vue&type=script&lang=js"
export * from "./CardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=389fa40e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389fa40e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389fa40e')) {
      api.createRecord('389fa40e', component.options)
    } else {
      api.reload('389fa40e', component.options)
    }
    module.hot.accept("./CardSkeleton.vue?vue&type=template&id=389fa40e&scoped=true", function () {
      api.rerender('389fa40e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/CardSkeleton.vue"
export default component.exports